import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, BrowserRouter as Router, Navigate } from 'react-router-dom';
//import CustomIntermediateNavigate from './components/CustomIntermediateNavigate';
// import useEventList from './hooks/useEventList';
// import useSessionCheck from './hooks/useSessionCheck';
// import AuthLayout from './pages/auth/dashboard/AuthLayout';
// import CompletedEventPage from './pages/auth/dashboard/CompletedEventPage';
// import CreateEvent from './pages/auth/dashboard/events/CreateEvent';
// import EditEvent from './pages/auth/dashboard/events/EditEvent';

// import GuestUserUploadPage from './pages/auth/dashboard/GuestUserUploadPage';
// import UserDashboard from './pages/auth/dashboard/UserDashboard';
import Dashboard from './pages/dashboard';
import KanbanPage from './pages/dashboard/KanbanPage';
import ProductionEventPage from './pages/events';
import GuestUserPage from './pages/guest';
import PageNotFound from './pages/shared/PageNotFound';
// import Signin from './pages/unauth/Signin';
// import Signup from './pages/unauth/Signup';
import { updateState } from './redux/commonSlice';
import CompletedEventPage from './pages/completedvideo';
import SignIn from './pages/unauthv2/signin';
import SignUp from './pages/unauthv2/signup';
import ResendLink from './pages/unauthv2/resendlink';
import ForgotPassword from './pages/unauthv2/forgotpassword';
import ResetPassword from './pages/unauthv2/resetpassword';
import InviteCollaborator from './pages/collaborator';
import UserMediaFiles from './pages/userfiles';
import TeamsDashboard from './pages/teamsdashboard';
import ReactGA from "react-ga4";
import { gaEvents } from './ga/actions';
import RedirectToAppStore from './redirects';
import AppleSignin from './pages/unauthv2/appleSignin';
import { isIos } from './utils/commonServices';
import MemberSignUp from './pages/unauthv2/memberSignup';
import { PERMISSION } from './constants/constants';
import CustomProtectedRoute from './components/CustomProtectedRoute';
import UserBrandbox from './pages/brandbox';
import { Box, CssBaseline, ThemeProvider, Typography } from '@mui/material';
import useCustomTheme from './theme/useCustomTheme';
import GuestReviewPage from './pages/guestreview';
import SigninAction from './pages/unauthv2/signinaction';
import PendingVerification from './pages/pendingverification';
import PendingQuickTurn from './pages/pendingquickturn';
import HiddenProjects from './pages/hiddenprojects';
import ProductAccess from './pages/productaccess';


// import { useSelector } from 'react-redux';

//lucimoments -----------------------
// const GOOGLE_ANALYTICS_ID="G-WT87Y5QVPK"


// ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID)


function App() {

   
  const commonReducer = useSelector((state) => state.root.commonReducer);

 
   const dispatch = useDispatch()
   const [theme] = useCustomTheme()

   useEffect(()=> {
    if(window.localStorage.getItem('token')) {
     // refetchSessionCheck()
      dispatch(updateState({ is_logged: true }));
    } else {
      dispatch(updateState({ is_logged: false }));
    }
   },[[window.localStorage.getItem('token')]])




  return (
  <ThemeProvider theme={theme}>
      <CssBaseline />
      <>
      <Router >
        {
          !commonReducer.is_logged ?  <Routes>
          <Route path= '/' element={<Navigate to='/signin' />} /> 
          {/* <Route path='/guestuploads' element={<GuestUserPage />} />  
          <Route path='/guestreview' element={<GuestReviewPage />} />  */}
          {/* <Route path='/signup' element={ <Signup/> } />
          <Route path='/signin' element={ <Signin/> } /> */}
          {/* <Route path='/invite-collaborator' element = {<InviteCollaborator /> } />
          <Route path='/signup' element={ <SignUp/> } />
          <Route path='/signin-action' element={ <SigninAction/> } /> */}
          {/* <Route path='/applesignin' element={ <AppleSignin/> } /> */}
          <Route path='/member-signup' element={ <MemberSignUp/> } />
          <Route path='/signin' element={ <SignIn/> } />
          <Route path='/forgotpassword' element={ <ForgotPassword/> } />
          <Route path='/resendlink' element={<ResendLink/>} />
          <Route path='/resetpassword' element={ <ResetPassword/> } />
          <Route path= '*' element={<Navigate to='/signin' />} />
        </Routes> :
        
          <Routes>
             <Route path= '/' element={<Navigate to='/dashboard' />} /> 
            <Route path='/dashboard' element={ <Dashboard/> } />
            <Route path='/dashboard/kanban' element={<Navigate to='/dashboard' />} />
            <Route path='/dashboard/teams' element={ <TeamsDashboard/> } />
            {/* <Route path='/guestuploads' element={isIos() ? <RedirectToAppStore /> : <GuestUserPage />} />   */}
            {/* <Route path='/guestuploads' element={<GuestUserPage />} />  
            <Route path='/invite-collaborator' element = {<RedirectToAppStore /> } />
            <Route path='/realestate-verify' element = {<RedirectToAppStore /> } />
            <Route path='/realestate-resetpassword' element = {<RedirectToAppStore /> } /> */}
            {/* <Route path='/guestuploads' element = {<RedirectToAppStore /> } /> */}
            {/* <Route path='/create-event' element={ <CreateEvent /> } /> 
            <Route path='/edit-event' element={ <EditEvent /> } />
            <Route path='/hdsbvjdsdfdsfsfhbv' element={<CustomIntermediateNavigate />} />
            <Route path='/completedevent' element={ <CompletedEventPage/> } /> */}
            <Route path='/productionevent' element={ <ProductionEventPage/> } />
            <Route path='/completedevent/:orgId/:projectId' element={ <CompletedEventPage/> } /> 
            <Route 
              path='/usermanagement' 
              element={<CustomProtectedRoute
                permission={commonReducer?.role_name === 'Admin'}
              >
                <PendingVerification />
              </CustomProtectedRoute> } />
            {/* <Route path='/myfiles' element={ <UserMediaFiles/> } /> */}
            <Route
              path='/myfiles'
              element={<UserMediaFiles />} />
            <Route
              path='/brandbox'
              element={<UserBrandbox />} />
              {/* <Route
              path='/usermanagement'
              element={<PendingVerification />} /> */}
           
            <Route
              path='/hiddenprojects'
              element={<CustomProtectedRoute permission={commonReducer?.role_name === 'Admin'}>
                <HiddenProjects />
              </CustomProtectedRoute>} />
            <Route
              path='/productaccess'
              element={<CustomProtectedRoute permission={commonReducer?.role_name === 'Admin'}>
                <ProductAccess />
              </CustomProtectedRoute>} />
            <Route
              path='/quickturnrequests'
              element={<CustomProtectedRoute permission={commonReducer?.role_name === 'Admin'}>
                <PendingQuickTurn />
              </CustomProtectedRoute>} />
            <Route path='*' element={ <PageNotFound/> } />
            {/* <Route path= '*' element={<Navigate to='/error-notfound-redirect' />} />  */}
          </Routes>  
        
        }
       
      </Router>
      </>
        
    </ThemeProvider>
    );
}

export default App;
